var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"product-grid d-flex justify-content-md-center"},[_c('div',{staticClass:"ss-header"},[_c('span',{staticClass:"title-desc"},[_c('strong',[_vm._v("Корзина пуста.")])])])])])
}]

export { render, staticRenderFns }